import type { RootState } from '@generalTypes/rootStateTypes';
import type { EditAsideDateToSendDatePicker } from '@nodeTypeConfig/configTypes';
import { patchDateToSendAction } from '@store/actions/documentActions';
import 'moment/locale/nl-be';
import { any } from 'prop-types';
import type React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectApiWithPendingChanges } from '@newStore/documentApi/documentApiSelectors';
import { createTypedSelector } from '@newStore/genericHelpers';
import DatePickerElement from './DatePicker';
import { convertDateToUTCISOString } from './dateHelper';

const selectDateToSendValue = createTypedSelector(
  [(state: RootState) => selectApiWithPendingChanges(state).newsletterSettings?.dateToSend],
  (dateToSend) => {
    return dateToSend ? new Date(dateToSend) : null;
  },
);

const AsideDateToSendPicker: React.FC<{
  config: EditAsideDateToSendDatePicker;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const dispatch = useDispatch();

  const initialValue = useSelector(selectDateToSendValue);

  const change = (value: Date | null) => {
    dispatch(patchDateToSendAction(value ? convertDateToUTCISOString(value) : undefined));
  };

  return (
    <DatePickerElement config={config} value={initialValue} onChange={change} readonly={readonly} />
  );
};

AsideDateToSendPicker.displayName = 'AsideDateToSendPicker';

export default AsideDateToSendPicker;

AsideDateToSendPicker.propTypes = {
  config: any,
  readonly: any,
};
